<script>
import { PlaceCategory } from '@/api'
import fields from '@/components/fields'
import FormMixin from '@/crudBases/form/FormMixin.vue'

export default {
  mixins: [FormMixin],
  data() {
    return {
      redirectRoute: { name: 'Categories List' }
    }
  },
  computed: {
    service() {
      return PlaceCategory
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Input({
          label: 'Nazwa',
          required: true,
          modelPath: [this, 'form', 'name'],
          multilingual: true
        }),
        new fields.Color({
          label: 'Kolor',
          required: true,
          modelPath: [this, 'form', 'color'],
          multilingual: false
        }),
        new fields.Image({
          label: 'Ikona',
          modelPath: [this, 'form', 'icon'],
          required: true,
          multilingual: false
        }),
        new fields.Select({
          label: 'Poziom zooma',
          modelPath: [this, 'form', 'zoom_level'],
          required: true,
          options: [
            {
              label: 'Pierwszy',
              value: 1
            },
            {
              label: 'Drugi',
              value: 2
            },
            {
              label: 'Trzeci',
              value: 3
            }
          ]
        })
      ]
    }
  }
}
</script>
